<template>
  <div class="blog-posts-page posts">
    <div>
      <div class="post-list-header row pt-3  align-items-center">
        <div
          class="page-header col-12 d-flex justify-content-between align-items-center"
        >
          <div class="page-header-left d-flex align-items-center">
            <h1 class="w-full mr-2">Posts</h1>
          </div>
          <div class="input-group search">
            <input
              class="form-control"
              type="text"
              v-model="keyword"
              placeholder="Search"
              @keyup="searchText($event)"
            />
            <button type="button" class="btn input-group-btn">
              <i
                :class="[keyword ? 'fa fa-remove' : 'fa fa-search']"
                @click="clearSearch"
              />
            </button>
          </div>
          <span
            class="header-right-side d-flex justify-content-center align-items-center"
          >
            <button
              @click.prevent="triggerDeployment()"
              class="btn btn-primary mr-4"
            >
              Deploy Posts
            </button>
            <button
              class="btn btn-primary mr-4"
              @click.prevent="$router.push('/posts/new')"
            >
              <b>Create New Post</b>
            </button>
            <button
              type="button"
              class="btn btn-secondary expand-all d-flex align-items-center"
              @click="toggleAllPosts"
            >
              <div
                :class="[
                  blogPosts && blogPosts.length === expanded.length
                    ? 'expand-icon'
                    : 'compress-icon'
                ]"
              />
            </button>
          </span>
        </div>

        <div class="filters-container my-3">
          <!-- Author Filters -->
          <span
            class="filter-option"
            :class="{ active: activeAuthor === 1 }"
            @click="getPosts(1, activeCategory, 1, activeLang)"
          >
            Marko
          </span>
          <span
            class="filter-option"
            :class="{ active: activeAuthor === 3 }"
            @click="getPosts(1, activeCategory, 3, activeLang)"
          >
            Bojan
          </span>

          <!-- Language Filters -->
          <img
            class="flag-img"
            :class="{ active: activeLang === 'sr' }"
            src="../../assets/img/filters/flags/sr.png"
            @click="getPosts(1, activeCategory, activeAuthor, 'sr')"
            alt="Serbian"
          />
          <img
            class="flag-img"
            :class="{ active: activeLang === 'en' }"
            src="../../assets/img/filters/flags/en.png"
            @click="getPosts(1, activeCategory, activeAuthor, 'en')"
            alt="English"
          />

          <!-- Clear Filters -->
          <span class="clear-filters" @click="clearFilters">Clear filters</span>
        </div>
      </div>
    </div>
    <template v-if="blogPosts && postsLoading">
      <vue-content-loading :width="800" :height="450">
        <rect
          v-for="x in 15"
          :key="x"
          x="10"
          :y="15 * x * 1.4"
          rx="5"
          ry="5"
          width="720"
          height="6"
        />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="mt-4" v-for="post in blogPosts" :key="post.id">
        <div class="post-container">
          <div class="d-flex post-header col-12 align-items-center">
            <div
              class="w-full d-flex align-items-center justify-content-between col-md-8 col-12"
            >
              <div
                class="w-full d-flex align-items-center post-title pointer"
                @click.middle.exact="viewMiddle($event, post.id)"
                @click.left.exact="view($event, post.id)"
              >
                {{ post.title }}
              </div>
              <div>
                <span v-if="post.user.id === 1">Marko</span>
                <span v-else>Bojan</span>
              </div>
              <div
                class="w-full d-flex align-items-center justify-content-center "
              >
                <span class="post-status" v-if="!post.is_draft"
                  ><i class="fa fa-circle green"></i> Published</span
                >
                <span class="post-status" v-else
                  ><i class="fa fa-circle red"></i> Draft</span
                >
              </div>
            </div>

            <div
              class="w-full d-flex align-items-center justify-content-between col-12 col-lg-4 pr-0"
            >
              <div class="w-full d-flex align-items-center col-2 col-md-4">
                <img
                  class="flag-img"
                  :src="
                    require(`../../assets/img/filters/flags/${post.lang}.png`)
                  "
                />
              </div>
              <div
                class="w-full d-flex align-items-center justify-content-end  col-2 col-md-4 pr-0"
              >
                <div class="options-buttons d-flex">
                  <div class="dropdown mr-2">
                    <button
                      class="btn btn-secondary dots-btn"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu dropdown-menu-right"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <div
                        class="pointer d-flex align-items-center dropdown-item pointer"
                        @click="$router.push('/post/' + post.id + '/comments')"
                      >
                        <i class="fa fa-comments-o mr-2"></i>
                        Comments ({{ post.comment_count }})
                      </div>
                      <div
                        class="d-flex align-items-center dropdown-item pointer"
                        @click.prevent="
                          $router.push({
                            name: 'New blog post',
                            params: { duplicatedPost: post }
                          })
                        "
                      >
                        <i class="fa fa-files-o mr-2"></i> Duplicate
                      </div>
                      <div
                        class="d-flex align-items-center dropdown-item pointer"
                        @click="deletePost(post.id)"
                      >
                        <i class="fa fa-trash mr-2 text-danger"></i> Delete
                      </div>
                    </div>
                  </div>
                  <button
                    class="btn btn-secondary"
                    @click="togglePost(post.id)"
                  >
                    <i
                      class="fa fa-caret-down caret"
                      :class="{ rotate: !expanded.includes(post.id) }"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr :class="[!expanded.includes(post.id) ? '' : 'hidden']" />
          <div
            class="post-expanded d-flex flex-row"
            :class="[!expanded.includes(post.id) ? '' : 'hidden']"
          >
            <div class="d-flex flex-row justify-content-start col-12 col-md-8">
              <div class="d-flex flex-column">
                <div class="expander-title">Post description</div>
                <div class="expander-description">
                  {{ post.meta_description }}
                </div>
              </div>
            </div>
            <div class=" d-flex flex-column justify-content-start col-4">
              <div class="h-full d-flex flex-row justify-content-between">
                <div
                  class="col-6 d-flex flex-column justify-content-between"
                  v-if="post.tags && post.category"
                >
                  <div>
                    <div class="expander-title">Tags</div>
                    <div class="expander-description">
                      <span
                        v-for="(tag, index) in post.tags.data"
                        :key="tag.id"
                      >
                        {{ tag.tag }}<span v-if="index - 1 !== 0">,</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <div class="expander-title">Category</div>
                    <div class="expander-description">
                      {{ post.category.data.name }}
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between flex-column alig-items-center"
                >
                  <div>
                    <div class="expander-title">Updated at</div>
                    <div class="expander-description">
                      {{ post.updated_at }}
                    </div>
                  </div>
                  <div></div>
                </div>

                <div>
                  <div class="expander-title"></div>
                  <div class="expander-description"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="blogPosts && !blogPosts.length && !postsLoading"
        class="claims mt-1"
      >
        No posts found...
      </div>

      <div class="row">
        <div
          class="col-md-6 mb-1 text-black-50"
          v-if="meta.pagination && meta.pagination.total"
        >
          Showing
          {{
            (meta.pagination.current_page - 1) * meta.pagination.per_page + 1
          }}
          -
          {{
            (meta.pagination.current_page - 1) * meta.pagination.per_page +
              meta.pagination.count
          }}
          of {{ meta.pagination.total }}
        </div>
        <pagination
          class="col-md-6 mb-1"
          :change-page="changePage"
          :meta="meta"
        />
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import Pagination from "@/components/Pagination";
/*
  import flatPickr from 'vue-flatpickr-component';*/

export default {
  name: "BlogPosts",
  components: {
    Pagination
  },
  data: () => ({
    blogPosts: null,
    config: {
      dateFormat: "m/j/Y",
      mode: "range"
    },
    expanded: [],
    filters: {
      createdDateStart: "",
      createdDateEnd: "",
      clusterUser: ""
    },
    keyword: "",
    meta: {},
    page: 1,
    q: "",
    showFilters: false,
    postsLoading: false,
    activeLang: "",
    activeCategory: "",
    activeAuthor: ""
  }),
  mounted() {
    this.getPosts(
      this.page,
      this.activeCategory,
      this.activeAuthor,
      this.activeLang
    );
  },
  methods: {
    getPosts(page, categoryId, authorId, lang) {
      this.postsLoading = true;
      const params = new URLSearchParams();
      if (categoryId) {
        this.activeCategory = categoryId;
        params.set("category", categoryId);
      }
      if (page) {
        this.page = page;
        params.set("page", this.page);
      }
      if (authorId) {
        this.activeAuthor = authorId;
        params.set("author", authorId);
      }
      if (lang) {
        this.activeLang = lang;
        params.set("lang", this.activeLang);
      }

      axios
        .get(`/posts?${params}`)
        .then(resp => {
          this.blogPosts = resp.data.data;
          this.meta = resp.data.meta;
          this.postsLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.postsLoading = false;
        });
    },
    searchBlogPosts(page, keyword) {
      axios
        .get(`/posts?include=tags,category&keyword=${keyword}&page=${page}`)
        .then(resp => {
          this.blogPosts = resp.data.data;
          this.meta = resp.data.meta;
        })
        .catch(error => {
          console.log(error);
        });
    },
    deletePost(postId) {
      axios
        .delete(`/posts/${postId}`)
        .then(() => {
          this.getPosts();
        })
        .catch(error => {
          console.log(error);
        });
    },
    togglePost(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(value);
      }
    },
    toggleAllPosts() {
      if (!this.expanded.length) {
        this.blogPosts.forEach(post => {
          this.expanded.push(post.id);
        });
      } else {
        this.expanded = [];
      }
    },
    viewMiddle(event, id) {
      const routeData = this.$router.resolve({
        path: `/posts/${id}`
      });
      window.open(routeData.href, "_blank");
    },
    view(event, id) {
      this.$router.push(`/posts/${id}`);
    },
    changePage(pageNum) {
      this.blogPosts = {};
      this.getPosts(pageNum, this.activeCategory,this.activeAuthor, this.activeLang );
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.search();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.blogPosts = {};
      this.activeLang = null;
      this.activeCategory = null;
      this.activeAuthor = null;
      this.searchBlogPosts(this.page, this.keyword);
    },
    clearSearch() {
      this.keyword = "";
      this.search();
    },
    clearFilters() {
      this.activeLang = null;
      this.activeCategory = null;
      this.activeAuthor = null;
      this.page = 1;
      this.getPosts();
    }
  }
};
</script>
<style scoped>
.filters-header {
  width: fit-content;
}
.dropdown-menu {
  min-width: auto;
}
.search {
  position: relative;
  max-width: 300px;
}
.search .form-control {
  padding-left: 35px;
  height: 42px;
  z-index: 10;
}
.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.search button,
.search .form-control {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  border: 0;
  background-color: transparent;
  outline: none;
}
.search button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  height: 42px;
}
.blog-posts-page .input-group.search {
  height: 42px;
}

@media screen and (max-width: 800px) {
  .blog-posts-page.posts {
    padding: 0 20px;
  }
  .post-list-header {
    padding-top: 0 !important;
  }
  .page-header-left h1 {
    text-align: center;
  }
  .blog-posts-page .input-group.search {
    margin: 0;
  }
  .header-right-side {
    margin-top: 20px;
  }
}
.filters-container {
  display: flex;
  align-items: center;
  gap: 1rem; /* Space between items */
}

.filter-option {
  padding: 0.3rem 0.75rem;
  font-size: 1rem;
  color: #6c757d; /* Neutral text */
  border: 1px solid transparent; /* Default transparent border */
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-option:hover {
  color: #006266; /* Blue text on hover */
}

.filter-option.active {
  font-weight: 600;
  color: #006266; /* Active blue */
  text-decoration: underline; /* Optional underline for active */
}

.flag-img {
  width: 32px;
  height: 20px;
  border: 1px solid transparent; /* No default border */
  cursor: pointer;
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.flag-img:hover {
  transform: scale(1.1); /* Slight hover zoom */
  border-color: #006266; /* Blue border on hover */
}

.flag-img.active {
  border: 2px solid #006266; /* Active blue border */
  border-radius: 4px; /* Rounded edges */
}

.clear-filters {
  font-size: 14px;
  color: #dc3545; /* Red for clear filters */
  cursor: pointer;
  transition: color 0.3s ease;
}

.clear-filters:hover {
  color: #c82333; /* Darker red on hover */
}
</style>
